import React, { FC, memo } from 'react';
import Ionicons from 'react-native-vector-icons/Ionicons';

import dynamicSize from '@webtrader/core/dynamic-size';

import { IVectorIconProps } from './index';

Ionicons.loadFont();

export type IoniconsName =
  | 'eye'
  | 'star'
  | 'earth'
  | 'refresh'
  | 'eye-off'
  | 'megaphone'
  | 'logo-apple'
  | 'logo-android'
  | 'close-outline'
  | 'radio-outline'
  | 'filter-outline'
  | 'wallet-outline'
  | 'person-outline'
  | 'chevron-back'
  | 'options-sharp'
  | 'star-outline'
  | 'card-outline'
  | 'copy-outline'
  | 'time-outline'
  | 'rocket-outline'
  | 'square-outline'
  | 'desktop-outline'
  | 'checkmark-sharp'
  | 'checkbox-outline'
  | 'calendar-outline'
  | 'contrast-outline'
  | 'hand-left-outline'
  | 'newspaper-outline'
  | 'lock-closed-outline'
  | 'person-circle-sharp'
  | 'finger-print-outline'
  | 'notifications-outline'
  | 'person-circle-outline'
  | 'swap-horizontal-outline'
  | 'checkmark-circle-outline'
  | 'information-circle-outline'
  | 'pricetags-outline'
  | 'logo-usd'
  | 'call-outline'
  | 'ellipsis-vertical'
  | 'checkmark-circle'
  | 'alert-circle';

const IoniconsIcon: FC<IVectorIconProps<IoniconsName>> = (props) => {
  const { name, color, size = 20, ...restProps } = props;

  return <Ionicons {...restProps} name={name} color={color} size={dynamicSize.convertSize(size)} />;
};

export default memo(IoniconsIcon);
